import { apiPost } from "../client";

export interface IUploadImageResponse {
  url: string;
  file_name: string;
  file_type: string;
  file_size: number;
}

export const apiUploadImage = async (
  file: File
): Promise<IUploadImageResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await apiPost<IUploadImageResponse>(
    "/upload-image",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data!;
};
